var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _line18, _path12, _path13, _line19, _line20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllSources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8418 23.8391V16.3783L19.2628 12.6484V20.108L11.8418 23.8391Z",
    fill: "#BFF2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42188 20.1058V12.4844L11.8429 16.3761V23.9978L4.42188 20.1058Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42188 12.4875L11.685 16.3794L19.264 12.4875M4.42188 12.4875L11.685 9.08203L19.264 12.4875M4.42188 12.4875V20.1092L11.8429 23.8389L19.264 20.1092V12.4875",
    stroke: "black",
    strokeWidth: 0.315789
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.78906,
    y1: 1.4632,
    x2: 13.5785,
    y2: 1.4632,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.2109,
    y1: 1.4632,
    x2: 15.4741,
    y2: 1.4632,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.89453,
    y1: 1.4632,
    x2: 9.15769,
    y2: 1.4632,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4.73633,
    y1: 5.35773,
    x2: 5.99949,
    y2: 5.35773,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6.63086,
    y1: 5.35773,
    x2: 7.89402,
    y2: 5.35773,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 8.52539,
    y1: 5.35773,
    x2: 9.78855,
    y2: 5.35773,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5781,
    y1: 5.35773,
    x2: 14.8413,
    y2: 5.35773,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 15.4746,
    y1: 5.35773,
    x2: 16.7378,
    y2: 5.35773,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 17.3691,
    y1: 5.35773,
    x2: 18.6323,
    y2: 5.35773,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 15.4746,
    y1: 9.24836,
    x2: 16.7378,
    y2: 9.24835,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 2.52539,
    y1: 9.24836,
    x2: 3.78855,
    y2: 9.24835,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 4.42188,
    y1: 9.24836,
    x2: 5.68503,
    y2: 9.24835,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 6.63086,
    y1: 9.24836,
    x2: 7.89402,
    y2: 9.24835,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 17.3691,
    y1: 9.24836,
    x2: 18.6323,
    y2: 9.24835,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 19.2637,
    y1: 9.24836,
    x2: 20.5268,
    y2: 9.24835,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 16.1055,
    y1: 1.4632,
    x2: 21.1581,
    y2: 1.4632,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 7.26367,
    y1: 1.45477,
    x2: 3.15841,
    y2: 1.45477,
    stroke: "black",
    strokeWidth: 0.315789
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92167 1.45947C2.92167 2.14071 2.38556 2.6821 1.73746 2.6821C1.08935 2.6821 0.553248 2.14071 0.553248 1.45947C0.553248 0.778237 1.08935 0.236842 1.73746 0.236842C2.38556 0.236842 2.92167 0.778237 2.92167 1.45947Z",
    fill: "#F5D983",
    stroke: "black",
    strokeWidth: 0.473684
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8162 5.3501C4.8162 6.03133 4.2801 6.57273 3.63199 6.57273C2.98389 6.57273 2.44778 6.03133 2.44778 5.3501C2.44778 4.66886 2.98389 4.12747 3.63199 4.12747C4.2801 4.12747 4.8162 4.66886 4.8162 5.3501Z",
    fill: "#F5D983",
    stroke: "black",
    strokeWidth: 0.473684
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60526 9.24463C2.60526 9.92587 2.06916 10.4673 1.42105 10.4673C0.772948 10.4673 0.236842 9.92587 0.236842 9.24463C0.236842 8.56339 0.772948 8.022 1.42105 8.022C2.06916 8.022 2.60526 8.56339 2.60526 9.24463Z",
    fill: "#F5D983",
    stroke: "black",
    strokeWidth: 0.473684
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7635 1.45947C23.7635 2.14071 23.2274 2.6821 22.5793 2.6821C21.9312 2.6821 21.395 2.14071 21.395 1.45947C21.395 0.778237 21.9312 0.236842 22.5793 0.236842C23.2274 0.236842 23.7635 0.778237 23.7635 1.45947Z",
    fill: "#F5D983",
    stroke: "black",
    strokeWidth: 0.473684
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9217 5.3501C20.9217 6.03133 20.3856 6.57273 19.7375 6.57273C19.0894 6.57273 18.5532 6.03133 18.5532 5.3501C18.5532 4.66886 19.0894 4.12747 19.7375 4.12747C20.3856 4.12747 20.9217 4.66886 20.9217 5.3501Z",
    fill: "#F5D983",
    stroke: "black",
    strokeWidth: 0.473684
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8162 9.24463C22.8162 9.92587 22.2801 10.4673 21.632 10.4673C20.9839 10.4673 20.4478 9.92587 20.4478 9.24463C20.4478 8.56339 20.9839 8.022 21.632 8.022C22.2801 8.022 22.8162 8.56339 22.8162 9.24463Z",
    fill: "#F5D983",
    stroke: "black",
    strokeWidth: 0.473684
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73633 12.4875L11.8416 9.08203V16.3794L4.73633 12.4875Z",
    fill: "#3B8699"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9473 12.4874L11.9999 9.3125V16.055L18.9473 12.4874Z",
    fill: "#56BCF1"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 11.8415,
    y1: 1.29687,
    x2: 11.8415,
    y2: 23.6755,
    stroke: "black",
    strokeWidth: 0.315789
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63086 5.19141L9.63086 15.3548",
    stroke: "black",
    strokeWidth: 0.315789
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73633 9.08203L7.73633 14.3695",
    stroke: "black",
    strokeWidth: 0.315789
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 13.736,
    y1: 5.19141,
    x2: 13.736,
    y2: 15.2456,
    stroke: "black",
    strokeWidth: 0.315789
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 15.6325,
    y1: 9.08203,
    x2: 15.6325,
    y2: 14.2713,
    stroke: "black",
    strokeWidth: 0.315789
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSources);
export default __webpack_public_path__ + "static/media/all_sources.ae74a1f95616055118e1aa3989ae43b4.svg";
export { ForwardRef as ReactComponent };